import { Grid, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { PageBody } from '../../routes/PageBody'
import { useOrg } from '../organization/useOrg'

import { AdminRoleInputs } from './AdminRoleInputs'
import { CompanyProfileInstructions } from '../onboarding/steps/companyProfile'

/** * END FORM CONFIGURATION ***/

export const CompanyProfilePage = () => {
  const org = useOrg()
  if (!org) return null
  return (
    <PageBody maxWidth="md">
      <Typography variant="h1" gutterBottom>
        Company roles
      </Typography>
      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Instructions
          </Typography>
          <CompanyProfileInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <AdminRoleInputs />
        </Grid>
      </Grid>
    </PageBody>
  )
}
